/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Plans_PersonalInputs */

const es_admin_company_overview_plans_personal = /** @type {(inputs: Admin_Company_Overview_Plans_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const en_admin_company_overview_plans_personal = /** @type {(inputs: Admin_Company_Overview_Plans_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

/**
* | output |
* | --- |
* | "Personal" |
*
* @param {Admin_Company_Overview_Plans_PersonalInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_plans_personal = /** @type {((inputs?: Admin_Company_Overview_Plans_PersonalInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Plans_PersonalInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_plans_personal(inputs)
	return en_admin_company_overview_plans_personal(inputs)
});
export { admin_company_overview_plans_personal as "admin.company_overview.plans.personal" }